import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const EffluentTreatmentPlantsEtps: React.FC = () => {
  return (
    <>
      <PageHeader customClass="bg-breadcrumb-wtp" title="Effluent Treatment Plants (ETPs)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/waster_water_solutions.jpg" alt="" />
                </div>
                
              </div>
              <h1 className="mb-4">Effluent Treatment Plants (ETPs)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Effluent Treatment Plants (ETPs) are critical infrastructure for treating industrial wastewater before safe discharge or reuse. At Wasser Technochem (India) Ltd., we specialize in the design, execution, and operation of ETPs that comply with the most stringent norms from CPCB, SPCBs, and local pollution control authorities.</p>
              <p>Our ETPs are built to handle diverse effluent streams — from textile and chemical to automotive, pharmaceuticals, and food industries — removing pollutants, reducing COD/BOD levels, and ensuring environmental safety.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-tshirt text-primary me-2"></i>Textile dyeing & processing industries</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical & pharmaceutical manufacturing</p>
              <p><i className="fa fa-newspaper text-primary me-2"></i>Paper & pulp, sugar, and food industries</p>
              <p><i className="fa fa-car text-primary me-2"></i>Automotive and component washing lines</p>
              <p><i className="fa fa-paint-brush text-primary me-2"></i>Paint shops, electroplating & galvanizing plants</p>
              <p><i className="fa fa-wine-bottle text-primary me-2"></i>Distilleries, breweries, and oil refineries</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL provides custom-built turnkey ETPs based on the specific effluent characteristics of the industry.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-layer-group text-primary me-2"></i>Primary, Secondary, and Tertiary Treatment Systems</h5>
                <p className="ms-4">Including physico-chemical treatment, biological reactors, and polishing units.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cogs text-primary me-2"></i>Treatment Technologies:</h5>
                <div className="ms-4">
                  <p>• Coagulation & flocculation</p>
                  <p>• Clarifiers / Tube settlers</p>
                  <p>• Aeration tanks (ASP, SAFF, Extended Aeration)</p>
                  <p>• Chemical dosing systems</p>
                  <p>• Pressure sand & activated carbon filtration</p>
                  <p>• Disinfection (UV, ozone, chlorination)</p>
                  <p>• Sludge handling (thickener, filter press, decanter)</p>
                </div>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-plus-circle text-primary me-2"></i>Advanced Add-ons (Optional)</h5>
                <div className="ms-4">
                  <p>• Membrane-based systems (UF/RO/ZLD)</p>
                  <p>• COD reduction through AOP or ozone systems</p>
                  <p>• Online monitoring of pH, BOD, flow, and TSS</p>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Achieves &lt;30 ppm BOD and &lt;100 ppm COD consistently</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces fresh water consumption via recycling</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compact, modular, and scalable design</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Ensures NOC/Clearance from SPCB and CPCB</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Over 25 years of experience in industrial ETP execution</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house expertise in pilot studies, on-ground reports, and consent clearance</p>
              <p><i className="fa fa-star text-warning me-2"></i>O&M, AMC, and upgradation services available</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Trusted partner for leading industries</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default EffluentTreatmentPlantsEtps;
